import { VertSpacerSm } from '@apps-common/components/layout'

export const NonAllocatedSimCardSkeleton = () => (
  <div className='rounded-3xl w-full p-6 bg-skeleton border border-skeleton-border'>
    <div className='w-full text-text animate-pulse'>
      <div className='bg-skeleton-hi w-[70%] h-[16px] rounded-[10px]' />
      <VertSpacerSm />
      <div className='bg-skeleton-hi w-[60%] h-[16px] rounded-[10px]' />
      <VertSpacerSm />
      <div className='bg-skeleton-hi w-[60%] h-[16px] rounded-[10px]' />
      <VertSpacerSm />
      <div className='bg-skeleton-hi w-[50%] h-[16px] rounded-[10px]' />
      <div className='flex items-center justify-end mt-4'>
        <div className='w-[30px] h-[30px] rounded-full bg-skeleton-hi' />
      </div>
    </div>
  </div>
)
